var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAsset1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 224 66.34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ff7bac;}.cls-2{fill:none;stroke:#5d3233;stroke-linecap:round;stroke-miterlimit:10;stroke-width:20px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "base"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M88.76,12.83s-5.05,73.45,53.25,34S88.76,12.83,88.76,12.83Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_4",
    "data-name": "Layer 4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M10,28c116.15-53.2,204,28.32,204,28.32"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsset1);
export default __webpack_public_path__ + "static/media/Asset 1.d1a52602.svg";
export { ForwardRef as ReactComponent };